import { render } from "./TelegramOTPComponent.vue?vue&type=template&id=d15344cc&scoped=true"
import script from "./TelegramOTPComponent.vue?vue&type=script&lang=js"
export * from "./TelegramOTPComponent.vue?vue&type=script&lang=js"

import "./TelegramOTPComponent.vue?vue&type=style&index=0&id=d15344cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15344cc"]])

export default __exports__